import React, { useState, useRef, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
import { Button, Input, InputNumber, Select } from 'antd';
import "../styles/map.css"
import {  IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {motion} from "framer-motion"
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconUrl,
  iconUrl: iconUrl,
  shadowUrl: iconShadowUrl,
});

const Map = ({userData,setShowMap,handle_shop_adress}) => {
    const [places, setPlaces] = useState([]);
    const [loading_search, setloading_search] = useState(false);
    const [error_search, seterror_search] = useState(false);
   // const inputRef = useRef(null);
    let [searchPlaces,GetSearchPlaces]=useState("")

  const handleGoButton = () => {
    //const placeName = inputRef.current.value;
   // console.log(searchPlaces);
    setloading_search(true)
    seterror_search("")
    if (searchPlaces) {
      fetchPlaceCoordinates(searchPlaces);
    }
  };
  //console.log(process.env.REACT_APP_API_KEY?"True":"False")

  const fetchPlaceCoordinates = async (placeName) => {
    const apiKey = process.env.REACT_APP_API_KEY;
    // console.log(placeName);
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(
      placeName
    )}&key=${apiKey}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry;
        setPlaces([{ name: placeName, lat, lng }]);
        setloading_search(false)
        seterror_search("")
      } else {
        //console.log('Place not found.');
        setloading_search(false)
        seterror_search("Place not found.")
      }
    } catch (error) {
      console.error('Error fetching place coordinates:', error);
      setloading_search(false)
      setloading_search("Error fetching place coordinates")
    }
  };

  const MapClickHandler = () => {
    const map = useMap();

    useMapEvents({
      click: async (e) => {
        //console.log(e.latlng);
        const { lat, lng } = e.latlng;

        const placeName = await fetchPlaceName(lat, lng);
          //console.log(placeName);
        const place = {
          name: placeName,
          lat,
          lng,
        };
        setPlaces([place]);

        map.setView([lat, lng]);
      },
    });

    return null;
  };

  const fetchPlaceName = async (lat, lng) => {
    const apiKey = process.env.REACT_APP_API_KEY;
    //console.log(lat,lng);
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&key=${apiKey}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        return data.results[0].formatted;
      } else {
        return 'Unknown Place';
      }
    } catch (error) {
     // console.error('Error fetching place name:', error);
      return 'Unknown Place';
    }
  };

 
const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default behavior of newline insertion
      handleGoButton(); // 
    }
  };

  const NewLocationAdd=(place)=>{
    handle_shop_adress(place)
    setShowMap(false)

  }

  
  return (
    <div className='Maps-container'>
        <motion.div 
         initial={{opacity:0,scale:0}}
         animate={{opacity:1,scale:1}}
         transition={{duration:0.4}}
        className='Maps-box'>
            <div  className='Maps-above'>
                <div  className='Maps-search-area'> 
                        <div><Input 
                              onKeyDown={handleKeyDown}
                              value={searchPlaces} onChange={(e)=>GetSearchPlaces(e.target.value)}  placeholder="Search for a place" /></div>
                        <div><Button disabled={!searchPlaces} onClick={handleGoButton}>Go</Button></div>
                 </div>
                 <IconButton onClick={()=>setShowMap(false)}><CloseIcon style={{color:"red"}}/></IconButton>
            </div>

            <MapContainer center={[0, 0]} zoom={1} style={{ height: '400px' }}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <MapClickHandler />
                {places.length > 0 && (
                <Marker position={[places[0].lat, places[0].lng]}>
                    <Popup>Selected Place</Popup>
                    
                </Marker>
                )}
                {places.map((place, index) => (
                <Marker key={index} position={[place.lat, place.lng]}>
                    <Popup>
                    <div>
                        <h3>{place.name}</h3>
                        <p>
                        Latitude: {place.lat.toFixed(6)}, Longitude: {place.lng.toFixed(6)}
                        </p>
                        <Button onClick={()=>NewLocationAdd(place)}>Add</Button>
                    </div>
                    </Popup>
                </Marker>
                ))}
            </MapContainer>
      
        </motion.div>

    </div>
  );
};

export default Map;